//验证手机格式
const IsPhone = function(val){
	let reg = /^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,3,4,5,7,8,9]|8[0-9]|9[1,8,9])\d{8}$/;
    return reg.test(val);
}

//获取路径参数
const getQueryString = function(name) {

				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
				var r = window.location.search.substr(1).match(reg);
				if(r != null) return unescape(r[2]);
				return null;

			}

//日期格式的转换
const FormDates =  function (fmt,type) {
    let result = '';
    let date =  new Date(fmt);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    let m = date.getMinutes();
    m = m < 10 ? ('0' + m) : m;
    let s = date.getSeconds();
    s = s < 10 ? ('0' + s) : s;
    if(type == 'yyyy-MM-dd') result = y + '-' + MM + '-' + d ;
    else if(type == 'yyyy/MM/dd') result = y + '/' + MM + '/' + d ;
    else if(type == 'yyyy-MM-dd HH:mm:ss') result = y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    return  result;
};
//性别格式的转换
const FormSex =  function (value) {
    let result = ''
    if( value == 0) result = '未知的性别';
    if( value == 1) result = '男性';
    if( value == 2) result = '女性';
    if( value == 9) result = '未说明的性别';
    return result;
}
//政治面貌格式的转换
const FormPoliticl =  function (value) {
    let result = ''
    if( value == '01') result = '中国共产党党员';
    if( value == '02') result = '中国共产党预备党员';
    if( value == '03') result = '中国共产主义青年团团员';
    if( value == '04') result = '中国国民党革命委员会会员';
    if( value == '05') result = '中国民主同盟盟员';
    if( value == '06') result = '中国民主建国会会员';
    if( value == '07') result = '中国民主促进会会员';
    if( value == '08') result = '中国农民民主党党员';
    if( value == '09') result = '中国致公党党员';
    if( value == '10') result = '九三学社社员';
    if( value == '11') result = '台湾民主自治同盟盟员';
    if( value == '12') result = '无党派民主人士';
    if( value == '13') result = '群众';
    if( value == '14') result = '国民党';
    if( value == '99') result = '其他';
    if( value == '102') result = '特殊对象';
    if( value == '103') result = '外国情报人员';
    if( value == '104') result = '反动会道门成员';
    if( value == '105') result = '敌特组织成员';
    if( value == '00') result = '无';
    return result;
}
//是否主联系人
const IsMain =  function (value) {
    let result = ''
    if( value == 0) result = '否';
    if( value == 1) result = '是';
    if( value == 2) result = '未知';
    return result;
}

const getCookie =  function (value) {
    let result = ''
    if(document.cookie.length > 0) {
					begin = document.cookie.indexOf(NameOfCookie + "=");
					if(begin !== -1) {
						begin += NameOfCookie.length + 1;
						end = document.cookie.indexOf("&", begin);
						if(end === -1) end = document.cookie.length;
						return unescape(document.cookie.substring(begin, end));
					}
				}
				return null;
}

export default {
    FormDates, FormSex,IsMain,FormPoliticl,IsPhone,getQueryString,getCookie
}



// WEBPACK FOOTER //
// ./src/utils/common.js